import { useState } from "react";

export const useEmailService = () => {
  const [fetching, setFetching] = useState(false);
  const [client, setClient] = useState(null);

  const checkEmail = (email: string) => {
    setFetching(true);

    return fetch("https://us-central1-my-ci-crm.cloudfunctions.net/findEmail", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email })
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .finally(() => {
        setFetching(false);
      });
  };

  const checkPin = (email: string, pin: string) => {
    setFetching(true);

    return fetch("https://us-central1-my-ci-crm.cloudfunctions.net/findClient", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email, pin })
    })
      .then((response) => response.json())
      .then((data) => {
        setClient(data);
        return data;
      })
      .finally(() => {
        setFetching(false);
      });
  };

  const resetPin = (email: string) => {
    setFetching(true);

    return fetch("https://us-central1-my-ci-crm.cloudfunctions.net/resetPin", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email })
    })
      .then((response) => response.json())
      .then((data) => {
        alert(`Your new PIN was sent to ${email}.`);
        return data;
      })
      .finally(() => {
        setFetching(false);
      });
  };
  
  return {
    fetching,
    checkEmail,
    checkPin,
    resetPin
  }
};